import { cn } from "@/lib/utils";
import { ContentCardSekeleton } from "components/domain/contents/cards/ContentCardSkeleton";
import { fireEvent } from "lib/ga";
import React, { useMemo } from "react";
import { ContentSection } from "types/app";

import { Separator } from "../../core/Seperator";
import { ContentCard } from "./cards/ContentCard";

export const ContentGrid = ({
    contents,
    contentSection,
    loading,
    showSkeleton = false,
    empty
}: {
    contents: Array<Mix_ContentFragment>;
    contentSection: ContentSection;
    loading: boolean;
    showSkeleton?: boolean;
    empty?: React.ReactNode;
}) => {
    const showEmpty = useMemo(
        () => !loading && contents.length === 0,
        [loading, contents.length]
    );

    return (
        <div
            className={cn(
                "animate-slidein h-full w-full",
                showEmpty
                    ? "flex items-center justify-center"
                    : "flex flex-col gap-y-6 md:grid md:grid-cols-[repeat(auto-fill,minmax(270px,1fr))] md:gap-x-6 md:gap-y-16"
            )}
        >
            {contents.length > 0
                ? contents.map((content) => (
                      <React.Fragment key={content.id}>
                          <ContentCard
                              type={
                                  content.isoriginal
                                      ? content.released
                                          ? "original"
                                          : "upcoming"
                                      : "curation"
                              }
                              content={content}
                              onClick={() => {
                                  const params = {
                                      content_section: contentSection,
                                      content_url: content.originalurl,
                                      content_isoriginal: content.isoriginal,
                                      content_released: content.released
                                  };

                                  fireEvent({
                                      event: "content_click",
                                      params: {
                                          content_id: content.id,
                                          content_title: content.title,
                                          ...params
                                      }
                                  });

                                  // window.fbq("track", "ViewContent", {
                                  //   ...params,
                                  //   content_ids: [content.id],
                                  //   content_name: content.title,
                                  //   content_type: "product",
                                  // });
                              }}
                          />
                          <Separator className="m-0 flex md:hidden" />
                      </React.Fragment>
                  ))
                : loading
                  ? showSkeleton && (
                        <>
                            <ContentCardSekeleton />
                            <ContentCardSekeleton />
                            <ContentCardSekeleton />
                            <ContentCardSekeleton />
                            <ContentCardSekeleton />
                            <ContentCardSekeleton />
                        </>
                    )
                  : empty}
        </div>
    );
};
